import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';

export const changePassword = createAsyncThunk(
  'user/changePassword',
  (params) => EcomEngineAPI.account.changePassword(params)
);

export const userSlice = createSlice({
  name: 'user',
  initialState: window.ecom.redux_initial_state.user,
  reducers: {
    setUser: (state, action) => action?.payload,
    setUserPreferences: (state, action) => {
      state.preferences = action.payload;
    },
  },
  extraReducers: {
    [changePassword.pending]: (state) => {
      state.changePasswordStatus = 'updating';
      state.changePasswordErrorMessage = '';
    },
    [changePassword.fulfilled]: (state) => {
      state.changePasswordStatus = 'succeeded';
      state.changePasswordErrorMessage = '';
    },
    [changePassword.rejected]: (state, action) => {
      state.changePasswordStatus = 'failed';
      state.changePasswordErrorMessage = action.error.message;
    },
  },
});

export const { setUser, setUserPreferences } = userSlice.actions;
export default userSlice.reducer;
